(function () {
    var pole = document.currentScript.previousElementSibling;
    var cel = document.querySelector('[data-search-desktop-slot]');
    if (!cel || !window.matchMedia) return;
    // Jedno pole zachowuje stan; na telefonie wraca pod naglowek.
    var miejsce = document.createComment('search-mobile');
    pole.parentNode.insertBefore(miejsce, pole);
    var desktop = window.matchMedia('(min-width: 1024px)');
    function ustaw() {
        if (desktop.matches) cel.appendChild(pole);
        else miejsce.parentNode.insertBefore(pole, miejsce.nextSibling);
    }
    ustaw();
    if (desktop.addEventListener) desktop.addEventListener('change', ustaw);
    else desktop.addListener(ustaw);
})();
